import { Injectable, Output, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';

// Entidades
import { Credito } from '../modelos/credito';


//Real time notification by Isaac
import * as io from 'socket.io-client';
//import { SocketClient } from 'src/app/webSocket/socketClient';
import { Msg } from 'src/app/utilerias/mensajes/Msg';
import { catchError } from 'rxjs/operators';
import { Persona } from 'src/app/shared/model/persona/persona';
import { Pagos } from '../modelos/pagos';
import { Pagare } from '../modelos/pagare';
import { Cotizacion } from '../modelos/cotizacion';
import { Aval } from '../modelos/aval';
import { UrlConstantes } from 'src/app/utilerias/constantes/urlconstantes';
import { Coacreditado } from '../modelos/coacreditado';
import { ConsultaList } from 'src/app/shared/model/core/ConsultaList.model';
import { Usuario } from 'src/app/shared/model/security/usuario.model';
import { LoginDto } from 'src/app/shared/model/security/logindto.model';
import { PagareAmortizacion } from '../modelos/pagare-amortizacion';
import { Reestructura } from '../modelos/reestructura.model';
import { archivoPldXml } from '../modelos/archivoPldXml';
import { CancelacionPago } from '../modelos/CancelacionPago';
import { CondonacionMoratorios } from '../modelos/CondonacionMoratorios';
import { PersonaCredito } from '../modelos/persona-credito';
import { EstatusCredito } from '../modelos/estatus-credito';
import { Renovacion } from '../modelos/renovacion';
import { ConvenioEmbargo } from '../modelos/convenio-embargo';
import { AplicacionPagoDto } from '../modelos/aplicacion-pago-dto';
import { AplicacionCreditoDto } from '../modelos/aplicacion-credito-dto';

const API_URL = environment.apiUrl;
const SUBMODULO = 'credito/';
@Injectable({
  providedIn: 'root'
})

export class CreditosService //extends SocketClient 
{
  user: Usuario;
  private headers = new HttpHeaders();


  @Output() limpia: EventEmitter<any> = new EventEmitter();
  @Output() tablaAmortizacion: EventEmitter<any> = new EventEmitter();
  @Output() clienteSeleccionado: EventEmitter<any> = new EventEmitter();
  @Output() archivoPld: EventEmitter<any> = new EventEmitter();

  @Output() totalAvales: EventEmitter<any> = new EventEmitter();
  @Output() totalCoacred: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router, private http: HttpClient, private ms: Msg) {
    this.headers = this.headers.set('Content-Type', 'application/json');
    this.headers = this.headers.set('Accept', 'application/json');
  }

  imprimirTablaAmortizacion(idCredito: number) {
    return this.http.get(API_URL + SUBMODULO + 'tablaAmortizacion/' + idCredito, { headers: this.crearAuthToken(), responseType: 'blob' });
  }

  imprimirPagare(idCredito: number) {
    return this.http.get(API_URL + SUBMODULO + 'reportePagare/' + idCredito, { headers: this.crearAuthToken(), responseType: 'blob' });
  }

  consultaCreditoById(idCredito: number): Observable<any> {
    return this.http.get(API_URL + SUBMODULO + "buscar/" + idCredito, { headers: this.crearAuthToken() });
  }

  consultaCreditoByIdAprobado(idCredito: number): Observable<any> {
    return this.http.get(API_URL + SUBMODULO + 'getCreditoAprobado/' + idCredito, { headers: this.crearAuthToken() });
  }


  consultaCreditos(): Observable<any> {
    return this.http.get(API_URL + SUBMODULO, { headers: this.crearAuthToken() });
  }

  consultaCreditosSeguimiento(): Observable<any> {
    return this.http.get(API_URL + SUBMODULO + 'buscaCreditosSeguimiento', { headers: this.crearAuthToken() });
  }

  guardarDatosCliente(idCredito: number, persona: Persona) {
    return this.http.post(API_URL + SUBMODULO + 'datosCliente/' + idCredito, persona, { headers: this.crearAuthToken() }).pipe(
      catchError(err => {
        console.error(err);
        return throwError("User defined error.");
      })
    )
  }

  guardarListaClientes(idCredito: number, clientes: Credito) {
    return this.http.post(API_URL + SUBMODULO + 'datosCliente/lista/' + idCredito, clientes,  { headers: this.crearAuthToken() }).pipe(
      catchError(err => {
        console.error(err);
        return throwError("User defined error.");
      })
    )
  }

  guardarDatosCredito(idCredito: number, producto: any) {
    return this.http.post(API_URL + SUBMODULO + 'datosCredito/' + idCredito, producto, { headers: this.crearAuthToken() });
  }

  guardarObligados(idCredito: number, obligados: Persona[]) {
    return this.http.post(API_URL + SUBMODULO + 'obligados/' + idCredito, obligados, { headers: this.crearAuthToken() });
  }
  guardarAval(bean: ConsultaList<Aval>) {
    return this.http.post(UrlConstantes.guardaAval, bean, { headers: this.crearAuthToken() });
  }
  guardarCoacreditado(bean: ConsultaList<Coacreditado>) {
    return this.http.post(UrlConstantes.guardaCoacreditado, bean, { headers: this.crearAuthToken() });
  }

  enviarRevision(idCredito: number, idAnalista: number) {
    return this.http.put<Credito>(API_URL + SUBMODULO + 'enviarRevision/' + idCredito + idAnalista, null, { headers: this.crearAuthToken() });
  }

  aprobar(idCredito: number, comentario: String) {
    return this.http.put(API_URL + SUBMODULO + 'aprobar/' + idCredito, { comentario }, { headers: this.crearAuthToken() });
  }


  rechazar(idCredito: number, comentario: String) {
    return this.http.put(API_URL + SUBMODULO + 'rechazar/' + idCredito, { comentario }, { headers: this.crearAuthToken() });
  }

  aceptarCredito(idCredito: number) {
    return this.http.put(API_URL + SUBMODULO + 'aceptar/' + idCredito, null, { headers: this.crearAuthToken() });
  }

  activarCredito(idCredito: number) {
    return this.http.put(API_URL + SUBMODULO + 'activar/' + idCredito, null, { headers: this.crearAuthToken() });
  }

  calcularResumen(idCredito: number) {
    return this.http.get(API_URL + SUBMODULO + 'calcularResumen/' + idCredito, { headers: this.crearAuthToken() });
  }

  obtenerTablaAmortizacion(idCredito: number) {
    return this.http.get(API_URL + SUBMODULO + 'calcularTablaAmortizacion/' + idCredito, { headers: this.crearAuthToken() });
  }

  guardaTablaAmortizacion(amortizacion: any[], idCredito: number) {
    return this.http.post(API_URL + SUBMODULO + 'guardatTablaAmortizacion/' + idCredito, amortizacion, { headers: this.crearAuthToken() });
  }

  obtenerTablaAmortizacionPDF() {
    return this.http.get(API_URL + 'download/pdf/nombrepdf', { headers: this.crearAuthToken(), responseType: 'blob' });
  }

  limpiar() {
    this.limpia.emit();
  }

  ablaAmortizacionEmitter(data) {
    this.tablaAmortizacion.emit(data);
  }

  imprimirContratoDeCredito(idCredito: number) {
    return this.http.get(API_URL + SUBMODULO + 'contratoCredito/' + idCredito, { headers: this.crearAuthToken(), responseType: 'blob' });
  }
  getPagares(idCredito: number) {
    return this.http.get<Pagos>(API_URL + SUBMODULO + 'pagoPagaresCredito/' + idCredito, { headers: this.crearAuthToken() });
  }

  suguimientoParams(params: Persona, page: number) {
    return this.http.post<any>(API_URL + SUBMODULO + 'consultaCreditosParams/' + page, params, { headers: this.crearAuthToken() });
  }
  imprimirReporteSaladosDeCredito(idCredito: number, pagos: Pagare[]) {
    return this.http.get(API_URL + SUBMODULO + 'reporteSaldoDeUnCredito/' + idCredito, { headers: this.crearAuthToken(), responseType: 'blob' });
  }
  imprimirRepSaldosPorCredito() {
    return this.http.get(API_URL + SUBMODULO + 'repSaldosPorCredito/', { headers: this.crearAuthToken(), responseType: 'blob' });
  }

  imprimirRepGananciasRangoFecha(fechas: Pagare) {
    return this.http.post(API_URL + SUBMODULO + 'repGananciasPorRangoFechas', fechas, { headers: this.crearAuthToken() });
  }
  reporteInteres(fechas: Pagare) {
    return this.http.post(API_URL + SUBMODULO + 'interes', fechas, { headers: this.crearAuthToken(), responseType: 'blob' });
  }

  reporteCapital(fechas: Pagare) {
    return this.http.post(API_URL + SUBMODULO + 'capital', fechas, { headers: this.crearAuthToken(), responseType: 'blob' });
  }

  reporteCapitalInteres(fechas: Pagare) {
    return this.http.post(API_URL + SUBMODULO + 'capitalInteres', fechas, { headers: this.crearAuthToken(), responseType: 'blob' });
  }

  convertirCreditoSolicitud(cotizacion: Cotizacion) {
    return this.http.post<Credito>(API_URL + SUBMODULO + 'convertirCotizacion/', cotizacion, { headers: this.crearAuthToken() });
  }

  actualizarCredito(credito: Credito) {
    return this.http.post<Credito>(API_URL + SUBMODULO + 'actualizarCredito/', credito, { headers: this.crearAuthToken() });
  }

  cancelarAutorizacionCredito(credito: Credito) {
    return this.http.post<Credito>(API_URL + SUBMODULO + 'CancelarAutorizacionCredito/', credito, { headers: this.crearAuthToken() });
  }

  cancelarFondeoCredito(credito: Credito) {
    return this.http.post<Credito>(API_URL + SUBMODULO + 'CancelarFondeoCredito/', credito, { headers: this.crearAuthToken() });
  }

  renovarCredito(renovacion: Renovacion) {
    return this.http.post<any>(API_URL + SUBMODULO + 'renovarCredito/', renovacion);
  }

  solicitudRenovacionCredito(renovacion: Renovacion) {
    return this.http.post<any>(API_URL + 'renovacion/solicitudRenovacionCredito/', renovacion, { headers: this.crearAuthToken() });
  }

  consultarCreditoidCotizacion(idCotizacion: number) {
    return this.http.post<any>(API_URL + SUBMODULO + 'getCreditoByidCotizacion/', idCotizacion, { headers: this.crearAuthToken() });
  }

  validaCredenciales(usuario: string, password: string) {
    this.user = new Usuario(usuario, btoa(password));
    return this.http.post<LoginDto>(API_URL + 'validaCredenciales', this.user, { headers: this.crearAuthToken() });
  }

  actualizacionFondeo(credito: Credito) {
    return this.http.post<any>(UrlConstantes.actualizacionFondeo, credito, { headers: this.crearAuthToken() })
  }

  guardarReestructura(reestructura: Reestructura) {
    return this.http.post<any>(UrlConstantes.guardarReestructura, reestructura, { headers: this.crearAuthToken() })
  }

  consultaReestructurasPagares(reestructura: Reestructura) {
    return this.http.post<any>(UrlConstantes.consultarReestructurasPagares, reestructura, { headers: this.crearAuthToken() })
  }

  consultarReestructuras(consulta: ConsultaList<Reestructura>) {
    return this.http.post<any>(UrlConstantes.CONSULTAR_REESTRUCTURAS, consulta, { headers: this.crearAuthToken() })
  }

  consultarDetallesReestructura(reestructuras: Reestructura) {
    return this.http.post<any>(UrlConstantes.CONSULTAR_DETALLE_REESTRUCTURA, reestructuras, { headers: this.crearAuthToken() })
  }

  actualizarReestructura(reestructura: Reestructura) {
    return this.http.post<any>(UrlConstantes.actualizarReestructura, reestructura, { headers: this.crearAuthToken() })
  }

  guardarConvevioEmbargo(convenioEmbargo: ConvenioEmbargo) {
    return this.http.post<any>(API_URL + UrlConstantes.SOLICITAR_CONVENIO, convenioEmbargo, { headers: this.crearAuthToken() })
  }

  autorizarEmbargo(convenioEmbargo: ConvenioEmbargo) {
    return this.http.post<any>(API_URL + UrlConstantes.EMBARGAR, convenioEmbargo, { headers: this.crearAuthToken() })
  }

  consultarConvenio(consulta: ConsultaList<ConvenioEmbargo>) {
    return this.http.post<any>(API_URL + UrlConstantes.CONSULTAR_CONVENIO_EMBARGO_PAGINADO, consulta, { headers: this.crearAuthToken() })
  }

  consultarConvenioExist(idPersona: number, idCredior: number) {
    return this.http.get<any>(API_URL + UrlConstantes.CONSULTAR_CONVENIO_EMBARGO_EXIST + "/" + idPersona + "/" + idCredior, { headers: this.crearAuthToken() })
  }

  consultarRenovacion(consulta: ConsultaList<Renovacion>) {
    return this.http.post<any>(UrlConstantes.CONSULTAR_RENOVACION, consulta, { headers: this.crearAuthToken() })
  }

  consultarDetallesRenovacion(renovacion: Renovacion) {
    return this.http.post<any>(UrlConstantes.CONSULTAR_DETALLE_RENOVACION, renovacion, { headers: this.crearAuthToken() })
  }

  actualizarRenovacion(renovacion: Renovacion) {
    return this.http.post<any>(UrlConstantes.actualizarRenovacion, renovacion, { headers: this.crearAuthToken() })
  }

  consultarSolicitudesCancelacionPagos(consulta: ConsultaList<CancelacionPago>) {
    return this.http.post<any>(UrlConstantes.consultarSolicitudesCancelacion, consulta, { headers: this.crearAuthToken() })
  }

  consultaSolicitudesCondonacionMoratorios(consulta: ConsultaList<CondonacionMoratorios>) {
    return this.http.post<any>(UrlConstantes.consultarSolicitudesCondonacionMoratorios, consulta, { headers: this.crearAuthToken() })
  }

  actualizarSolicitudCondonacion(solicitud: CondonacionMoratorios) {
    return this.http.post<any>(UrlConstantes.actualizarSolicitudCondonacion, solicitud, { headers: this.crearAuthToken() })
  }

  actualizarSolicitudCancelacion(solicitud: CancelacionPago) {
    return this.http.post<any>(UrlConstantes.actualizarSolicitudCancelacion, solicitud, { headers: this.crearAuthToken() })
  }

  consultaFacturas(consulta: ConsultaList<Credito>) {
    return this.http.post<any>(UrlConstantes.consultarFacturasPaginado, consulta, { headers: this.crearAuthToken() })
  }

  consultaEstadosDeCuenta(consulta: ConsultaList<Credito>) {
    return this.http.post<any>(UrlConstantes.consultarEstadosDeCuentaPaginado, consulta, { headers: this.crearAuthToken() })
  }

  consultarPagosRealizados(consulta: ConsultaList<Credito>) {
    return this.http.post<any>(UrlConstantes.consultarPagosRealizadosPaginado, consulta, { headers: this.crearAuthToken() })
  }

  consultarPagaresPaginados(consulta: ConsultaList<Credito>) {
    return this.http.post<any>(UrlConstantes.consultarPagaresPaginados, consulta, { headers: this.crearAuthToken() })
  }

  guardarSolicitudCancelacion(cancelacion: CancelacionPago) {
    return this.http.post<any>(UrlConstantes.guardarSolicitudCancelacion, cancelacion, { headers: this.crearAuthToken() })
  }

  guardarSolicitudCondonacion(condonacion: CondonacionMoratorios) {
    return this.http.post<any>(UrlConstantes.guardarSolicitudCondonacion, condonacion, { headers: this.crearAuthToken() })
  }

  consultaNotasCargo(consulta: ConsultaList<Credito>) {
    return this.http.post<any>(UrlConstantes.consultarNotasCargoPaginado, consulta, { headers: this.crearAuthToken() })
  }

  guardarMovimientoCredito(credito: Credito) {
    return this.http.post<any>(UrlConstantes.guardarMovimientoCredito, credito, { headers: this.crearAuthToken() })
  }

  consultaTablaPagareAmortizacionByIdCredito(credito: Credito): Observable<any> {
    return this.http.post<any>(API_URL + 'creditoConsultaSaldos/ConsultaTablaPagareAmortizacionByIdCredito', credito, { headers: this.crearAuthToken() });
  }

  consultaDeSaldoParaAplicacionPagoPorCredito(credito: Credito): Observable<AplicacionPagoDto[]> {
    return this.http.post<AplicacionPagoDto[]>(API_URL + 'creditoConsultaSaldos/consultaDeSaldoParaAplicacionPagoPorCredito', credito, { headers: this.crearAuthToken() });
  }

  consultaTablaPagareAmortizacionByIdCreditoAndPersona(titular: PersonaCredito): Observable<PagareAmortizacion[]> {
    return this.http.post<PagareAmortizacion[]>(API_URL + 'creditoConsultaSaldos/ConsultaTablaPagareAmortizacionByIdCreditoAndIdPersona', titular, { headers: this.crearAuthToken() });
  }

  consultaCreditoByPersonaAndEstatusCredito(persona: Persona, estatus: number): Observable<any> {
    let titular: PersonaCredito = new PersonaCredito();
    titular.persona = persona;
    titular.credito = new Credito();
    titular.credito.estatus = new EstatusCredito();
    titular.credito.estatus.id = estatus;
    return this.http.post<any>(API_URL + 'creditoConsultaSaldos/ConsultaCreditoByPersonaAndEstatusCredito', titular, { headers: this.crearAuthToken() });
  }

  consultaMetodosPago(): Observable<any> {
    return this.http.get(API_URL + 'creditoConsultaSaldos/ConsultaMetodosDePago', { headers: this.crearAuthToken() });
  }

  guardaAplicacionPagosPagaresCredito(aplicacionPagoDto: AplicacionPagoDto[]) {
    return this.http.post<AplicacionPagoDto[]>(API_URL + 'creditoConsultaSaldos/guardaPagosPagaresCredito', aplicacionPagoDto, { headers: this.crearAuthToken() });
  }

  guardaAplicacionPagosCredito(aplicacionCreditoDto: AplicacionCreditoDto[]) {
    return this.http.post<AplicacionCreditoDto[]>(API_URL + 'creditoConsultaSaldos/guardaPagosPagaresCreditoMasivo', aplicacionCreditoDto, { headers: this.crearAuthToken() });
  }

  consultaPagareIdCredito(idCredito: Credito) {
    return this.http.post<ConsultaList<PagareAmortizacion>>(UrlConstantes.consultaPagare, idCredito, { headers: this.crearAuthToken() });
  }

  consultaArchivoPld(monto: number) {
    return this.http.post<ConsultaList<any>>(UrlConstantes.consultarArchivoPld, monto, { headers: this.crearAuthToken() });
  }
  consultaArchivoPldXml(objeto: any) {
    return this.http.post<ConsultaList<archivoPldXml>>(UrlConstantes.consultarArchivoPldxml, objeto, { headers: this.crearAuthToken() });
  }

  obtenerGestoresCobranzaDeCreditosActivos(): Observable<any> {
    return this.http.get<any>(API_URL + 'obtenerGestoresCobranzaDeCreditosActivos.do', { headers: this.crearAuthToken() });
  }

  consultaEstadosPago(): Observable<any> {
    return this.http.get<any>(API_URL + 'consultaEstatusPago.do', { headers: this.crearAuthToken() });
  }

  consultaCreditoPld(monto: number) {
    return this.http.post<ConsultaList<any>>(UrlConstantes.CONSULTA_INFCREDITOBYPLD, monto, { headers: this.crearAuthToken() });
  }

  eliminarPld(pld: any) {
    return this.http.post<ConsultaList<any>>(UrlConstantes.eliminarPld, pld, { headers: this.crearAuthToken() });
  }

  obtenerEstatusCreditoLista(): Observable<any> {
    return this.http.get<any>(API_URL + 'estatusCredito/consultaListaEstatusCredito.do', { headers: this.crearAuthToken() });
  }

  obtenerEstatusCreditoConsultaSaldo(): Observable<any> {
    return this.http.get<any>(API_URL + 'estatusCredito/consultaListaEstatusCreditoConsultaSaldo.do', { headers: this.crearAuthToken() });
  }

  obtenerTipoCreditoLista(): Observable<any> {
    return this.http.get<any>(API_URL + 'tipoCredito/consultaListaTiposCredito.do', { headers: this.crearAuthToken() });
  }

  obtenerOperadoresColocacion(): Observable<any> {
    return this.http.get<any>(API_URL + 'obtenerOperadoresColocacionActivos.do', { headers: this.crearAuthToken() });
  }

  obtenerOperadoresSeguimientoCobranza(): Observable<any> {
    return this.http.get<any>(API_URL + 'obtenerOperadoresSeguimientoCobranzaActivos.do', { headers: this.crearAuthToken() });
  }

  descargarReporteArchivoExcel(httpParams: HttpParams): Observable<Blob> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'X-Auth-Token': localStorage.getItem('tkCocred'),
    });

    return this.http.get(API_URL + 'descargaReporteArchivoExcel.do/', {
      params: httpParams,
      headers: headers,
      responseType: 'blob'
    });
  }

  actualizarCreditoPersona(credito: Credito) {
    return this.http.post<Credito>(API_URL + SUBMODULO + 'actualizarCreditoPersona.do/', credito, { headers: this.crearAuthToken() });
  }

  consultaEstatus(): Observable<any> {
    return this.http.get<any>(UrlConstantes.CONSULTAR_ESTATUS_CONVENIO, { headers: this.crearAuthToken() });
  }

  private crearAuthToken() {
    const token = localStorage.getItem('tkCocred');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      'X-Auth-Token': token,
    });
  }
}
